// *******************
//
// Para inativar o logoff automatico de qualquer tela, basta colocar a anotação "/?timeout=false",
// antes de qualquer rota, isso automaticamente ira desativar o logoff automatico.
//
// Exemplo de caso de uso: FEEDBACK_FATURA_PINPAD = "/?timeout=false/atendimento/feedback-fatura-pinpad".
//
// ********************
import ClienteCelular from "components/security/ClienteCelular";
import ClienteCPF from "components/security/ClienteCPF";
import ClientePushSMS from "components/security/ClientePushSMS";
import ClienteSenha from "components/security/ClienteSenha";
import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import {
  addIDLojaState,
  addNomeLojaState,
} from "redux/features/security/security-slice";
import Swal from "sweetalert2";
import AntecipationPurchase from "views/Atendimento/AntecipationPurchase";
import AntecipationHistory from "views/Atendimento/AntecipationPurchase/AntecipationHistory";
import ResumeAntecipationPayment from "views/Atendimento/AntecipationPurchase/ResumeAntecipation";
import Extrato from "views/Atendimento/Extrato";
import Fatura from "views/Atendimento/Fatura";
import ChoosePayments from "views/Atendimento/Fatura/ChoosePayments";
import PagarPix from "views/Atendimento/Fatura/PagarPix";
import ProofPayment from "views/Atendimento/Fatura/PagarPix/ProofPayment";
import ParcelamentoFatura from "views/Atendimento/Fatura/ParcelamentoFatura";
import FeedbackPinpad from "views/Atendimento/Fatura/PaymentDebitCredit/FeedbackPinPad";
import FeedUserPOS from "views/Atendimento/Fatura/PaymentDebitCredit/FeedUserPOS";
import CreditInstallment from "views/Atendimento/Fatura/PaymentDebitCredit/FluxCredit/CreditInstallment";
import CreditSummary from "views/Atendimento/Fatura/PaymentDebitCredit/FluxCredit/CreditSummary";
import DebitSummary from "views/Atendimento/Fatura/PaymentDebitCredit/FluxDebit/DebitSummary";
import ValueCapture from "views/Atendimento/Fatura/PaymentDebitCredit/ValueCapture";
import Limite from "views/Atendimento/Limite/Limite";
import Negocie from "views/Atendimento/Negocie";
import ClienteConfirmarSenha from "views/Desbloqueio/ClienteCriarSenha/confirmarSenha";
import ClienteCriarSenha from "views/Desbloqueio/ClienteCriarSenha/criarSenha";
import ClienteDataNascimento from "views/Desbloqueio/ClienteDataNascimento";
import ClienteNumeroCartao from "views/Desbloqueio/ClienteNumeroCartao";
import ClienteSenhaUsuarioAtivo from "views/Desbloqueio/ClienteSenhaUsuarioAtivo";
import Proposta from "views/PedirOTeu/Proposta";
import TermoPDF from "views/PedirOTeu/TermoPDF";
import TermoPrivacidadePDF from "views/PedirOTeu/TermoPrivacidadePDF";
import TermoWhatsApp from "views/PedirOTeu/TermoWhatsApp";
import { LOCAL_STORE_ID_LOJA, LOCAL_STORE_NOME_LOJA } from "../constants";
import AtendimentoHome from "../views/Atendimento/AtendimentoHome/AtendimentoHome";
import BloqueioCartaoEscolhaMotivo from "../views/Atendimento/BloqueioCartao/BloqueioCartaoEscolhaMotivo/BloqueioCartaoEscolhaMotivo";
import BloqueioSelecionaCartao from "../views/Atendimento/BloqueioCartao/BloqueioSelecionaCartao/BloqueioSelecionaCartao";
import BloqueioConcluido from "../views/Atendimento/BloqueioCartao/BloqueioConcluido/BloqueiConcluido";
import BloqueioDesignCartao from "../views/Atendimento/BloqueioCartao/BloqueioDesignCartao/BloqueioDesignCartao";
import BloqueioQuerSegundaVia from "../views/Atendimento/BloqueioCartao/BloqueioQuerSegundaVia/BloqueioQuerSegundaVia";
import Home from "../views/Home/Home";

export enum RouteNames {
  SECURITY_CLIENTE_CPF = "/security-cpf",
  SECURITY_CLIENTE_SENHA = "/security-senha",
  SECURITY_SENHA_DESBLOQUEIO_USUARIO_ATIVO = "/security-senha-desbloqueio-usuario-ativo",
  CLIENTE_CELULAR = "/cliente-celular",
  UNLOCK_CLIENTE_CARTAO = "/unlock-cartao",
  UNLOCK_CLIENTE_DATA_NASCIMENTO = "/unlock-data-nascimento",
  UNLOCK_CLIENTE_CRIAR_SENHA = "/unlock-criar-senha",
  UNLOCK_CLIENTE_CONFIRMAR_SENHA = "/unlock-confirmar-senha",
  UNLOCK_CLIENTE_PUSH_SMS = "/unlock-push-sms",
  HOME = "/",
  BLOQUEIO_SELECIONA_CARTAO = "/bloqueio-cartao/selecionar-cartao",
  BLOQUEIO_ESCOLHA_MOTIVO = "/bloqueio-cartao/escolher-motivo",
  BLOQUEIO_CARTAO_ESCOLHA_MOTIVO_AUTH = "/bloqueio-cartao/escolha-motivo-auth",
  BLOQUEIO_QUER_SEGUNDA_VIA = "/bloqueio-cartao/quer-2a-via",
  BLOQUEIO_DESIGN_CARTAO = "/bloqueio-cartao/bloqueio-design-cartao",
  BLOQUEIO_CARTAO_CONCLUIDO = "/bloqueio-cartao/bloqueio-finalizado",
  ATENDIMENTO_HOME = "/atendimento/start",
  ATENDIMENTO_LIMITE = "/atendimento/limite",
  ATENDIMENTO_EXTRATO = "/atendimento/extrato",
  ATENDIMENTO_FATURA = "/atendimento/fatura",
  ATENDIMENTO_ANTECIPACAO = "/atendimento/antecipacao",
  ANTECIPACAO_HISTORICO = "/atendimento/antecipacao-historico",
  NEGOCIE = "/negocie",
  TERMO_E_CONDICOES = "/termos-e-condicoes",
  TERMO_DE_USO_PDF = "/termos-PDF",
  TERMO_PRIVACIDADE_PDF = "/termos-privacidade-PDF",
  PROPOSTA = "/proposta",
  PARCELAS_FATURA = "/atendimento/parcelas",
  ESCOLHA_PAGAMENTO = "/atendimento/escolha-tipo-pagamento",
  PAGAMENTO_PIX_FATURA = "/atendimento/pagar-por-pix",
  CAPTURA_VALOR_FATURA_PAGAMENTO = "/atendimento/captura-valor-fatura",
  RESUMO_CREDITO_FATURA_PAGAMENTO = "/atendimento/resumo-credito-fatura-pagamento",
  FEEDBACK_FATURA_PAGAMENTO = "/atendimento/feedback-fatura-pagamento",
  RESUMO_DEBITO_FATURA_PAGAMENTO = "/atendimento/resumo-debito-fatura-pagamento",
  FEEDBACK_FATURA_PINPAD = "/?timeout=false/atendimento/feedback-fatura-pinpad",
  PARCELAMENTO_CREDITO_FATURA_PAGAMENTO = "/atendimento/parcelamento-credito-fatura-pagamento",
  COMPROVANTE_PAGAMENTO_PIX = "/atendimento/comprovante",
  RESUMO_ANTECIPACAO_COMPRA = "/atendimento/resumo-antecipacao-compra",
}

// tentativa de capturar um not timeout
export function getRotaAtual() {
  if (window.location.pathname) {
    const paramUrl = window.location.search
      .substring(1)
      .split("/?") as string[];
    const t1 = paramUrl[0].split("/");
    const t2 = t1.filter((c) => c === "timeout=false");
    const isNotTimeout = t2[0] ? true : false;

    return {
      url: t1[1],
      isNotTimeout,
    };
  }
}

const Routes = () => {
  const { typeFlow } = useAppSelector((state) => state.security);
  const [isIdle, setIsIdle] = useState(false);
  const [timer, setTimer] = useState(60);

  const dispatch = useAppDispatch();

  const handleOnIdle = (event: any) => {
    if (
      typeFlow === "atendimento" ||
      typeFlow === "fatura" ||
      typeFlow === "limite" ||
      typeFlow === "proposta" ||
      typeFlow === "desbloqueio" ||
      typeFlow === "fatura-pagamento-credito" ||
      typeFlow === "fatura-pagamento-debito" ||
      typeFlow === "antecipacao"
    ) {
      const rotaAtual = getRotaAtual();

      if (!rotaAtual?.isNotTimeout) {
        Swal.fire({
          icon: "warning",
          title: "Que pena....!",
          text: "Você ficou mais de 15 segundos sem interagir. Deseja continuar?",
          showConfirmButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#33A733",
          timer: 15000,
          allowOutsideClick: false,
          timerProgressBar: true,
        }).then((result: any) => {
          // QUANDO O USUARIO NÃO CLICA NO BOTAO CONTINUAR
          if (!result.value) {
            setIsIdle(true);
          }
          // QUANDO O USUARIO NAO CLICA NO BOTAO E DEIXA O TIMER PASSAR
          if (result.dismiss === "timer") {
            setIsIdle(true);
          }
          setIsIdle(false);
        });
      }
    }
  };

  useEffect(() => {
    if (typeFlow === "fatura-pix") {
      timer > 0 && setTimeout(() => setTimer(timer - 1), 1000);
    }

    if (typeFlow !== "fatura-pix") {
      setTimer(180);
    }
  }, [timer, typeFlow]);

  const onIdle = (event: any) => {
    if (typeFlow === "fatura-pix" || typeFlow === "fatura-pagamento") {
      const rotaAtual = getRotaAtual();

      if (!rotaAtual?.isNotTimeout) {
        Swal.fire({
          icon: "warning",
          title: "Que pena....!",
          text: "Você ficou mais de 03 minutos sem interagir. Deseja continuar?",
          showConfirmButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#33A733",
          timer: 15000,
        }).then((result) => {
          console.log("----> Result", result);
          if (!result.value) {
            setIsIdle(true);
          }
          if (result.isConfirmed) {
            setTimer(180);
            setIsIdle(false);
          }
        });
      }
    }
  };

  const handleOnActive = (event: any) => {
    setIsIdle(false);
  };

  useIdleTimer({
    timeout: 15000,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });

  useIdleTimer({
    timeout: 180000,
    onIdle: onIdle,
    onActive: handleOnActive,
    debounce: 500,
  });

  useEffect(() => {
    function getOrigem() {
      if (window.location.search) {
        const paramUrl = window.location.search
          .substring(1)
          .split("/?") as string[];
        const paramUrl_ID = paramUrl[0];
        const paramUrl_Nome = paramUrl[1].replaceAll("%20", " ");
        console.log("Url loja", { paramUrl_ID, paramUrl_Nome });
        dispatch(addIDLojaState(paramUrl_ID));
        dispatch(addNomeLojaState(paramUrl_Nome));
        localStorage.setItem(LOCAL_STORE_ID_LOJA, paramUrl_ID);
        localStorage.setItem(LOCAL_STORE_NOME_LOJA, paramUrl_Nome);
      } else {
        // To Do - Criar uma modal para informa q esta loja nao esta cadastrada.
        // Ou criar uma exeção para cuidar destes casos.
      }
    }
    getOrigem();
  }, [dispatch]);

  return (
    <BrowserRouter>
      {isIdle &&
        [
          "atendimento",
          "fatura",
          "desbloqueio",
          "proposta",
          "fatura-pix",
          "limite",
          "fatura-pagamento",
          "fatura-pagamento-credito",
          "fatura-pagamento-debito",
          "antecipacao",
        ].includes(typeFlow) && <Redirect to={RouteNames.HOME} />}
      <Switch>
        {/* ! Home */}
        <Route path={RouteNames.HOME} exact>
          <Home />
        </Route>

        <Route path={RouteNames.BLOQUEIO_SELECIONA_CARTAO} exact>
          <BloqueioSelecionaCartao />
        </Route>

        <Route path={RouteNames.BLOQUEIO_ESCOLHA_MOTIVO} exact>
          <BloqueioCartaoEscolhaMotivo />
        </Route>

        <Route
          path={RouteNames.SECURITY_CLIENTE_CPF}
          component={(props: any) => {
            return <ClienteCPF {...props.history.location.state} />;
          }}
          exact
        />

        <Route
          path={RouteNames.SECURITY_CLIENTE_SENHA}
          component={(props: any) => {
            return <ClienteSenha {...props.history.location.state} />;
          }}
          exact
        />

        <Route
          path={RouteNames.SECURITY_SENHA_DESBLOQUEIO_USUARIO_ATIVO}
          component={(props: any) => {
            return <ClienteSenhaUsuarioAtivo {...props.history.location.state} />;
          }}
          exact
        />

        <Route
          path={RouteNames.CLIENTE_CELULAR}
          component={(props: any) => {
            return <ClienteCelular {...props.history.location.state} />;
          }}
          exact
        />

        <Route
          path={RouteNames.UNLOCK_CLIENTE_CRIAR_SENHA}
          component={(props: any) => {
            return <ClienteCriarSenha {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.UNLOCK_CLIENTE_CONFIRMAR_SENHA}
          component={(props: any) => {
            return <ClienteConfirmarSenha {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.UNLOCK_CLIENTE_PUSH_SMS}
          component={(props: any) => {
            return <ClientePushSMS {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.UNLOCK_CLIENTE_CARTAO}
          component={(props: any) => {
            return <ClienteNumeroCartao {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.UNLOCK_CLIENTE_DATA_NASCIMENTO}
          component={(props: any) => {
            return <ClienteDataNascimento {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.TERMO_E_CONDICOES}
          component={(props: any) => {
            return <TermoWhatsApp {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.TERMO_DE_USO_PDF}
          component={(props: any) => {
            return <TermoPDF {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.TERMO_PRIVACIDADE_PDF}
          component={(props: any) => {
            return <TermoPrivacidadePDF {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.PROPOSTA}
          component={(props: any) => {
            return <Proposta {...props.history.location.state} />;
          }}
        />

        <Route
          path={RouteNames.BLOQUEIO_QUER_SEGUNDA_VIA}
          component={BloqueioQuerSegundaVia}
        />

        <Route
          path={RouteNames.BLOQUEIO_DESIGN_CARTAO}
          component={BloqueioDesignCartao}
        />

        <Route
          path={RouteNames.BLOQUEIO_CARTAO_CONCLUIDO + "/:solicitarSegundaVia"}
          component={BloqueioConcluido}
        />

        <Route path={RouteNames.ATENDIMENTO_HOME} exact>
          <AtendimentoHome />
        </Route>

        <Route path={RouteNames.ATENDIMENTO_LIMITE}>
          <Limite />
        </Route>

        <Route path={RouteNames.ATENDIMENTO_EXTRATO}>
          <Extrato />
        </Route>

        <Route path={RouteNames.ATENDIMENTO_FATURA}>
          <Fatura />
        </Route>

        <Route path={RouteNames.ATENDIMENTO_ANTECIPACAO}>
          <AntecipationPurchase />
        </Route>

        <Route path={RouteNames.ANTECIPACAO_HISTORICO}>
          <AntecipationHistory />
        </Route>

        <Route path={RouteNames.PARCELAS_FATURA}>
          <ParcelamentoFatura />
        </Route>

        <Route
          path={RouteNames.ESCOLHA_PAGAMENTO}
          component={(props: any) => {
            return <ChoosePayments {...props.history.location.state} />;
          }}
          exact
        />

        <Route
          path={RouteNames.PAGAMENTO_PIX_FATURA}
          render={(props: any) => {
            return <PagarPix {...props} timer={timer} />;
          }}
        />

        <Route
          path={RouteNames.COMPROVANTE_PAGAMENTO_PIX}
          render={(props: any) => {
            return <ProofPayment {...props} timer={timer} />;
          }}
        />

        <Route
          path={RouteNames.RESUMO_ANTECIPACAO_COMPRA}
          render={(props: any) => {
            return <ResumeAntecipationPayment {...props} timer={timer} />;
          }}
        />

        <Route
          path={RouteNames.CAPTURA_VALOR_FATURA_PAGAMENTO}
          component={(props: any) => {
            return <ValueCapture {...props.history.location.state} />;
          }}
          exact
        />

        <Route path={RouteNames.RESUMO_CREDITO_FATURA_PAGAMENTO}>
          <CreditSummary />
        </Route>

        <Route path={RouteNames.PARCELAMENTO_CREDITO_FATURA_PAGAMENTO}>
          <CreditInstallment />
        </Route>

        <Route
          path={RouteNames.FEEDBACK_FATURA_PAGAMENTO}
          component={(props: any) => {
            return <FeedUserPOS {...props.history.location.state} />;
          }}
          exact
        />

        <Route path={RouteNames.RESUMO_DEBITO_FATURA_PAGAMENTO}>
          <DebitSummary />
        </Route>

        <Route
          path={RouteNames.FEEDBACK_FATURA_PINPAD}
          component={(props: any) => {
            return <FeedbackPinpad {...props.history.location.state} />;
          }}
          exact
        />

        <Route path={RouteNames.NEGOCIE}>
          <Negocie />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
